import React, { Fragment } from "react";
import FieldListFactory from "components/FieldListFactory";
import FieldLogicStatus from "components/FieldLogicStatus";

const ValuesFields = ({ name }) => {
  return (
    <Fragment>
      <FieldListFactory
        name={name}
        config={[
          {
            name: "label"
          },
          {
            name: "description"
          }
        ]}
      />
      <div className="pt3">
        <FieldLogicStatus name={name} />
      </div>
    </Fragment>
  );
};

export default ValuesFields;
